import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import FlightTypeReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/flight-type.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(FlightTypeReducer, defaultState, asyncActions);
};

type IFlightTypeContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const FlightTypeContext = createContext<Partial<IFlightTypeContext>>({
  state: defaultState,
}) as React.Context<IFlightTypeContext>;

const FlightTypeProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <FlightTypeContext.Provider value={{ ...reducer }}>
      {children}
    </FlightTypeContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useFlightTypeContext = () => useContext(FlightTypeContext);

export type IuseFlightTypeContext = ReturnType<typeof useFlightTypeContext>;

export { FlightTypeContext, FlightTypeProvider };
